import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { initMocks } from '@/mocks'
import setupLocatorUI from '@locator/runtime'
import App from './App'
import '@/styles/print.css'

if (import.meta.env.DEV) {
  setupLocatorUI()
}

/**
 * Application entry point.
 * Starts MSW mock worker (dev only), then renders the React app.
 */
const bootstrap = async () => {
  await initMocks()

  const root = document.getElementById('root')
  if (!root) throw new Error('Root element #root not found in index.html')

  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}

bootstrap()
